import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Flip({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 27 30" fill="currentColor">
      <polygon points="9 3 6 3 6 22.5 0 22.5 7.5 30 15 22.5 9 22.5 9 3" />
      <polygon points="19.5 0 12 7.5 18 7.5 18 27 21 27 21 7.5 27 7.5 19.5 0" />
    </SvgIcon>
  )
}
